import {Component, OnInit} from '@angular/core';
import {CoreConfigService} from '../../../@core/services/config.service';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

    constructor(public _coreConfigService: CoreConfigService) {
        this._coreConfigService.config = {
            layout: {
                menu: {
                    hidden: true
                },
                animation: 'none',
                customizer: false,
                enableLocalStorage: false,
                type: 'horizontal'
            }
        };
    }

    ngOnInit(): void {
    }

}
